export const characterGroups = ['全部', '主线人物', '情感线人物', '关系配角'];

export const characters = [
  {
    id: 'initiator',
    name: '同学会的发起人',
    group: '主线人物',
    tag: '故事引线',
    meta: '中年男性 · 事业家庭表面圆满',
    desc: '多年后重新联系上当年的同窗，主动张罗这场聚会。外人眼里他事业稳定、家庭和睦，只有他自己知道婚姻早已只剩下日程表。聚会成了他暂时逃离现实的出口。',
    line: '与当年的旧日心动对象重逢，试图补上青春里没说完的那句话。',
    icon: 'ri-user-star-line',
  },
  {
    id: 'monitor',
    name: '当年的班长',
    group: '主线人物',
    tag: '气氛担当',
    meta: '女性 · 组织能力出众',
    desc: '习惯性地承担气氛担当，擅长用热闹和酒局盖住自己的失落。她把每个人都拉回同一张桌子，散场后却独自面对突然安静下来的房间。',
    line: '看似掌控全场，其实最怕的就是曲终人散之后的那一刻。',
    icon: 'ri-women-line',
  },
  {
    id: 'crush',
    name: '被惦记的那位女同学',
    group: '情感线人物',
    tag: '白月光',
    meta: '已婚 · 生活规律而平淡',
    desc: '校园时代许多人心照不宣的“白月光”。如今已经结婚多年，日子规律、体面，却缺少波澜。重逢让她第一次认真打量自己当年的选择。',
    line: '一边是安稳的家庭，一边是突然被唤醒的旧日情绪。',
    icon: 'ri-heart-3-line',
  },
  {
    id: 'wife',
    name: '守着家的妻子',
    group: '情感线人物',
    tag: '沉默的暗线',
    meta: '主角伴侣 · 敏锐而克制',
    desc: '她并非迟钝，而是选择不去点破。用沉默维持表面的体面，也用自己的方式记录着所有细节。她的克制本身，就是故事的另一条暗线。',
    line: '不吵不闹，却让每一次越界都显得更沉重。',
    icon: 'ri-emotion-sad-line',
  },
  {
    id: 'bestie',
    name: '女主身边的闺蜜',
    group: '情感线人物',
    tag: '同盟与较量',
    meta: '女性 · 无话不谈',
    desc: '两人几乎无话不谈，既是彼此最信任的同盟，也在暗中比较各自的婚姻。她一边替朋友出主意，一边在心里反复衡量自己的处境。',
    line: '看似站队的人，其实也在替自己找答案。',
    icon: 'ri-group-line',
  },
  {
    id: 'businessman',
    name: '做生意的老同学',
    group: '关系配角',
    tag: '骗局起点',
    meta: '男性 · 精于人情与生意',
    desc: '那种把同学情谊和生意经混在一起的人。第二部的骗局线，正是从这样一张熟面孔开始——用最熟的关系，做最冷的计算。',
    line: '叙旧是敲门砖，账本才是他真正关心的东西。',
    icon: 'ri-briefcase-line',
  },
  {
    id: 'observer',
    name: '一直沉默的同学',
    group: '关系配角',
    tag: '观察者视角',
    meta: '话最少 · 看得最清',
    desc: '整场聚会里话最少的人，却常常是看得最清楚的那个。他像一面镜子，把其他人不愿承认的疲惫和侥幸一一照出来。',
    line: '不参与，但每一次沉默都像一句评价。',
    icon: 'ri-eye-line',
  },
  {
    id: 'newcomer',
    name: '后来入局的新面孔',
    group: '关系配角',
    tag: '新的变量',
    meta: '系列后段登场',
    desc: '系列后段出现的新关系，把原本封闭的熟人圈撕开一道口子，也让“同学会”这个设定有了新的走向和更难收拾的后果。',
    line: '旧关系还没收尾，新的牵连已经找上门。',
    icon: 'ri-user-add-line',
  },
];